import { TextField, Typography } from "@material-ui/core";
import React, { useCallback, useEffect } from "react";

import { CmsContentBlock, CmsContentBlockText } from "../../../../types/CmsPageData";
import { useCmsEditorContext } from "../../../masks/CmsEditorContext";
import { CmsContentEditor } from "../CmsContentEditor";
import { CmsContentTypeProps } from "./CmsContentTypeProps";

export interface CmsContentHeaderProps extends CmsContentTypeProps {
    contentNode: CmsContentBlockText;
    headerType: "h1" | "h2" | "h3" | "h4";
}

export function CmsContentHeader({
    contentNode,
    editMode,
    startEditMode,
    stopEditMode,
    showLayoutMenu,
    headerType,
}: CmsContentHeaderProps) {
    const { contentIndex, setContentIndex, setFormHasChangesAction } = useCmsEditorContext();

    const updateContentNode = useCallback(
        (newContent: CmsContentBlock) => {
            setContentIndex({
                ...contentIndex,
                [contentNode.id]: {
                    ...newContent,
                } as CmsContentBlock,
            });
            setFormHasChangesAction();
        },
        [contentIndex, setContentIndex, contentNode]
    );

    const updateContentData = useCallback(
        (newText: string) => {
            setContentIndex({
                ...contentIndex,
                [contentNode.id]: {
                    ...contentNode,
                    data: newText,
                } as CmsContentBlock,
            });
            setFormHasChangesAction();
        },
        [contentIndex, setContentIndex, contentNode]
    );

    useEffect(() => {
        if (!editMode && contentNode.data.length == 0) {
            startEditMode();
        }

        if (Array.isArray(contentNode.data) || typeof contentNode.data == "object") {
            // set an empty string if the content is an object or an array
            updateContentData("");
        }
    }, [contentNode.data, editMode]);

    if (!editMode) {
        return (
            <Typography variant={headerType} onClick={startEditMode} className={"cmsHoverContent"}>
                {contentNode.data ? contentNode.data : ""}
            </Typography>
        );
    }

    return (
        <CmsContentEditor
            stopEditMode={stopEditMode}
            contentNode={contentNode}
            updateContentNode={updateContentNode}
            showLayoutMenu={showLayoutMenu}
        >
            <TextField
                variant="outlined"
                value={contentNode.data ? contentNode.data : ""}
                onChange={(event) => {
                    updateContentData(event.target.value);
                }}
                fullWidth={true}
            />
        </CmsContentEditor>
    );
}
